export default (function (_ref) {
  var service = _ref.service,
      request = _ref.request,
      serviceForMock = _ref.serviceForMock,
      requestForMock = _ref.requestForMock,
      mock = _ref.mock,
      faker = _ref.faker,
      tools = _ref.tools;
  return {
    // 用户列表
    adminUserInfo: function adminUserInfo() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'adminUserInfo',
        method: 'get',
        data: data
      });
    },
    // 用户中中奖详情
    adminUserLottery: function adminUserLottery() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'adminUserLottery',
        method: 'get',
        data: data
      });
    },
    // 奖品总量列表
    lotteryNumData: function lotteryNumData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'lotteryNumData',
        method: 'get',
        data: data
      });
    },
    // 奖品数量配置
    lotteryNumConfig: function lotteryNumConfig() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'lotteryNumConfig',
        method: 'post',
        data: data
      });
    },
    // 兑换码列表
    lotteryCodeData: function lotteryCodeData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'lotteryCodeData',
        method: 'get',
        data: data
      });
    },
    // 上传兑换码
    lotteryCodeConfig: function lotteryCodeConfig() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'lotteryCodeConfig',
        method: 'post',
        data: data
      });
    },
    // 兑换码列表
    WelfarlotteryCodeData: function WelfarlotteryCodeData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'WelfarlotteryCodeData',
        method: 'get',
        data: data
      });
    },
    // 上传兑换码
    WelfarlotteryCodeConfig: function WelfarlotteryCodeConfig() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'WelfarlotteryCodeConfig',
        method: 'post',
        data: data
      });
    }
  };
});